export const enum OptionTypes {
  TYPE_DATE = 'typeDate',
  TYPE_RADIO = 'typeRadio',
  TYPE_CHECKBOX = 'typeCheckbox',
}
